(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mokurra-compact-summary')){
 customElements.define('mokurra-compact-summary',class extends HTMLElement{
  connectedCallback(){
   this.observer?.disconnect();
   this.prepareDiscount();
   this.observer=new MutationObserver(()=>{
    if(this.queued)return;this.queued=true;
    queueMicrotask(()=>{this.queued=false;if(this.isConnected)this.prepareDiscount()});
   });
   this.observer.observe(this,{childList:true,subtree:true,attributes:true,attributeFilter:['data-mk-savings','data-mk-savings-text']});
  }
  prepareDiscount(){
   this.prepareSavings();
   const summaries=this.querySelectorAll('cart-discount summary,.cart-discount summary,.cart-actions summary,summary.cart-discount__summary');
   for(const summary of summaries){
    if(summary.querySelector('.mk-cart-discount-label'))continue;
    const isDiscount=summary.closest('cart-discount,.cart-discount')||/discount|promo|order summary/i.test(summary.textContent||'');
    if(!isDiscount)continue;
    const walker=document.createTreeWalker(summary,NodeFilter.SHOW_TEXT),nodes=[];
    while(walker.nextNode())nodes.push(walker.currentNode);
    for(const node of nodes)node.textContent='';
    const label=document.createElement('span');label.className='mk-cart-discount-label';label.textContent='Have a discount code?';
    summary.appendChild(label);summary.classList.add('mk-cart-discount-toggle');
   }
  }
  prepareSavings(){
   const stacks=[...this.querySelectorAll('[data-mk-total-stack]')];
   const stack=stacks.pop();if(!stack)return;
   for(const duplicate of stacks)duplicate.remove();
   const candidates=[...this.querySelectorAll('span,p,div,dt,strong,h2,h3')];
   const label=candidates.find(el=>!stack.contains(el)&&el.childElementCount===0&&/^(total|estimated total)$/i.test((el.textContent||'').trim()));
   let totalRow=null;
   if(label){
    let parent=label.parentElement;
    for(let depth=0;parent&&parent!==this&&depth<5;depth++,parent=parent.parentElement){
     if(parent.contains(stack))break;
     const hasAmount=/[0-9][.,][0-9]{2}/.test(parent.textContent||'');
     const hasActions=parent.querySelector('button,input,summary,cart-discount');
     if(hasAmount&&!hasActions){totalRow=parent;break}
    }
   }
   if(totalRow){
    totalRow.classList.add('mk-cart-native-total-hidden');
    totalRow.setAttribute('aria-hidden','true');
    if(totalRow.previousElementSibling!==stack)totalRow.insertAdjacentElement('beforebegin',stack);
    return;
   }
   const checkout=[...this.querySelectorAll('button,input[type="submit"],a')].find(el=>/check\s*out|proceed to checkout/i.test(el.textContent||el.value||''));
   if(checkout){
    const action=checkout.closest('.cart__ctas,.cart__checkout-actions,.cart__checkout-button-container')||checkout;
    if(action.previousElementSibling!==stack)action.insertAdjacentElement('beforebegin',stack);
   }
  }
  disconnectedCallback(){this.observer?.disconnect()}
 });
}

if(!customElements.get('mokurra-cart-offers')){
 customElements.define('mokurra-cart-offers',class extends HTMLElement{
  connectedCallback(){
   this.observer?.disconnect();this.decorate();
   this.observer=new MutationObserver(()=>{
    if(this.queued)return;this.queued=true;
    queueMicrotask(()=>{this.queued=false;if(this.isConnected)this.decorate()});
   });
   this.observer.observe(this,{childList:true,subtree:true,characterData:true});
  }
  decorate(){
   let offers;
   try{offers=JSON.parse(this.querySelector('[data-mk-cart-offers]')?.textContent||'[]')}catch{return}
   const rows=this.querySelectorAll('[data-key], [data-cart-item-key],.cart-items__table-row');
   for(const row of rows){
    const key=row.dataset.key||row.dataset.cartItemKey;
    if(!key)continue;
    const offer=offers.find(item=>item.key===key);
    const old=row.querySelector('.mk-cart-line-badge');
    if(!offer||offer.percent<=0){old?.remove();continue}
    const compare=row.querySelector('s,del,.cart-items__price-compare,.compare-at-price');
    if(!compare)continue;
    const badge=old||document.createElement('span');
    if(!old)badge.className='mk-cart-line-badge';
    const text='Save '+offer.percent+'%';
    if(badge.textContent!==text)badge.textContent=text;
    if(compare.nextElementSibling!==badge)compare.insertAdjacentElement('afterend',badge);
   }
  }
  disconnectedCallback(){this.observer?.disconnect()}
 });
}
  } catch(e) { console.error(e); }
})();

})();
